import { apiService } from "api/apiService";

export interface RealtimeTranscriptionSession {
  token: string;
  model: string;
  url: string;
}

/**
 * Send a spoken recording to be transcribed and return the recognised text.
 *
 * The extension follows the blob's own type: Chrome and Firefox record webm,
 * Safari records mp4. The backend validates on the file's actual content, so
 * this only keeps the uploaded part honestly named.
 */
export const createTranscription = async (recording: Blob): Promise<string> => {
  const extension = recording.type.includes("mp4") === true ? "mp4" : "webm";

  const formData = new FormData();
  formData.append("audio", recording, `feedback.${extension}`);

  const { data } = await apiService.post<{ text: string }>(
    "api/catwise-ai/transcribe",
    formData,
  );

  return data.text;
};

/**
 * A single-use, short-lived token the browser may use to open Mistral's
 * realtime transcription socket directly.
 */
export const createRealtimeSession =
  async (): Promise<RealtimeTranscriptionSession> => {
    // Minted per recording, never cached: a token's expiry says nothing about
    // whether it still opens a socket, and reusing one across fields made every
    // recording after the first fail the handshake.
    const { data } = await apiService.post<{
      token: string;
      model: string;
      url: string;
    }>("api/catwise-ai/transcribe/realtime-session");

    return data;
  };
